export default __webpack_public_path__ + "static/media/default-cover.548e2eda.webp";